// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__34rF0","title":"ClientInsurance_title__p94Ry","itemText":"ClientInsurance_itemText__1-lsM"};